export const cdnDistributionIds = ["E27AFF7YW28OKI", "E2BEIARUJVGCUF"];